import { render, staticRenderFns } from "./ScreenPlataformas.vue?vue&type=template&id=51fcbc00"
import script from "./ScreenPlataformas.vue?vue&type=script&lang=js"
export * from "./ScreenPlataformas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports